// extracted by mini-css-extract-plugin
export default {"HorizontalLine":"FRvOHyeV"};